import { MDBIcon } from "mdb-react-ui-kit"
import { useWindowSize } from "../hooks/useWindowSize"
import { NavLink, useNavigate } from "react-router-dom";


export interface OperatorNavigationBarLinkProps {
    name: string;
    to?: string;
    icon?: string;
    onClick?: () => void;
}

export interface OperatorNavigationBarProps {
    backTo?: string;
    links: OperatorNavigationBarLinkProps[];
    right?: React.ReactNode;
    centerContent?: React.ReactNode;
}

export const OperatorNavigationBar = ({ backTo, links, right, centerContent }: OperatorNavigationBarProps) => {
    const { innerWidth } = useWindowSize();

    return (
        <nav
            className="navbar navbar-expand-lg navbar-light p-1 w-100 border-top mb-1"
            style={{ background: "#fc8c0342" }}
        >
            <div className="justify-content-between d-flex flex-row w-100 overflow-hidden">
                <div>
                    {typeof backTo == 'string' && <NavLink
                        to={backTo}
                        className="nav-link d-flex align-items-center p-1 user-select-none cursor-pointer"
                        style={{ cursor: "pointer" }}
                    >
                        <div className="d-flex align-items-center pe-1">
                            <MDBIcon icon="arrow-left" className="nav-link" style={{ fontSize: '1.8rem' }}/>
                        </div>
                    </NavLink>}
                </div>
                {innerWidth >= 600 &&
                    <div
                        className="d-flex flex-row flex-fill align-items-center justify-content-center text-center"
                        style={{ overflow: "hidden", marginLeft: -16 }}
                    >
                        { links.map((link, idx) => (
                            <div
                                key={idx+link.name+link.to}
                                className="d-flex flex-row align-items-center justify-content-end overflow-hidden"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                <NavLink to={link.to || ""} onClick={link.onClick}>
                                    <MDBIcon icon={link.icon} color="primary" size="sm" className="me-1"/>
                                    <span className="text-dark"
                                        style={{
                                            fontSize: idx == links.length-1 ? "1rem" : "0.9rem",
                                            fontWeight: idx == links.length-1 ? "bold" : "",
                                            overflow: "hidden",
                                            textOverflow: idx == links.length-1 ? "" : "ellipsis",
                                            cursor: idx == links.length-1 ? "" : "pointer",
                                        }}
                                    >
                                        {link.name}
                                    </span>
                                    { (idx < links.length - 1) && (
                                        <span style={{ fontSize: "0.9rem" }} className="me-1">&nbsp;/</span>
                                    ) }
                                </NavLink>
                                
                            </div>
                        ))}
                        { centerContent && <>
                            <div className="flex-fill"></div>
                            <div className="d-flex flex-row flex-fill align-items-center text-center"
                            style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
                                { centerContent }
                            </div>
                        </>
                            
                        }
                        
                        { right && (
                            <div className="d-flex flex-row position-absolute align-items-center" style={{right: 5}}>
                                { right }
                            </div>
                        )}
                    </div>
                }
                {innerWidth < 600 &&
                    <div
                        className="d-flex flex-column flex-fill align-items-start text-center"
                        style={{ overflow: "hidden" }}
                    >
                        { links.length > 0 && <div className="d-flex flex-row flex-fill align-items-center" style={{textOverflow: 'ellipsis'}}>
                            <MDBIcon icon={links[links.length-1].icon} color="primary" fixed className="me-1"/>
							<span className="d-flex flex-fill text-dark"
								style={{
									fontSize: "1rem",
									fontWeight: 'bold',
									whiteSpace: "nowrap",
									lineHeight: '1em',
								}}
							>
								{links[links.length-1].name}
							</span>
                        </div>
                        }
                        
                        <div
                            className="d-flex flex-row flex-fill align-items-center justify-content-end overflow-hidden"
                            style={{ whiteSpace: "nowrap" }}
                        >
                            {links.slice(0, -1).map((link, idx) => (
                                <NavLink key={idx+link.name+link.to} className="d-flex flex-row align-items-center" to={link.to || ""}>
                                    <MDBIcon icon={link.icon} color="primary" size="sm" fixed/>
                                    <span className="text-dark"
                                        style={{
                                            fontSize: "0.9rem",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {link.name}
                                    </span>
                                    { (idx < links.length - 2) && <span>&nbsp;/</span>}
                                </NavLink>
                            ))}
                            { centerContent && <>
                                <div className="d-flex flex-row flex-fill align-items-center text-center"
                                style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
                                    { centerContent }
                                </div>
                            </>
                                
                            }
                            { right && (
                                <div className="d-flex flex-row position-absolute align-items-center h-100" style={{right: 5, top: 0}}>
                                    { right }
                                </div>
                            )}
                        </div>
					</div>
                }
            </div>
        </nav>
    )
}